import * as React from 'react';
// import {logout as apiLogout} from '../api/auth-api';
import { Redirect } from 'react-router';
// import { getUserName } from '../api/auth-api';
import '../styles/Headers.css';
import NavButton, { NavButtonSize } from './NavButton';
import { Link } from 'react-router-dom';
import { getUserName, logOut, hasAdminRole, hasDistributorRole } from '../api/api-account';
const headerLogo = require('../images/header-logo-white.png');

export interface Props {

}

interface State {
  logout: Boolean
}

export class Header extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      logout: false,
    }
  }

  handleLogout = () => {
    logOut();
    this.setState({ logout: true });
  }

  render() {
    let isCustomer:boolean = !(hasAdminRole()||hasDistributorRole())
    if (this.state.logout) {
      return <Redirect to={{
        pathname: '/login'
      }} />;
    } else {
      return (
          <div className="header nav-divider container-fluid d-flex row align-items-center">
            <img
              className="ml-2 mr-2 mb-15 mw-100 mh-100"
              src={headerLogo}
              alt="header logo"
              width={250}
            />
            <div className="nav nav-button justify-content-left align-items-end d-flex">
              <NavButton
                text="Spool Winders"
                path='/spoolWinders'
                size={NavButtonSize.large}
                alternatePaths={['/', '/main', '/index']}
              />
              <NavButton
                text="Cut Records"
                path='/cutRecords'
                size={NavButtonSize.large}
              />
              <NavButton
                text="Alarms"
                path='/alarms'
                size={NavButtonSize.large}
              />
              <NavButton
                text="OEE"
                path='/oee'
                size={NavButtonSize.large}
              />
              <NavButton
                text="Users"
                path='/users'
                size={NavButtonSize.large}
              />
              {!isCustomer&&<NavButton
                text="Organizations"
                path='/organizations'
                size={NavButtonSize.large}
              />}
            </div>
            <div className="row ml-auto mr-0 label-medium loggedInText">
              <div>
                Logged in as: <br />
                {getUserName()} <br />
                <Link className="underlined-italic logggedInLink" to="/account">Manage Account</Link>
              </div>
              <button
                className="ml-3 mr-5 btn btn-outline-secondary button-standard"
                onClick={this.handleLogout}
              >
                Logout
              </button>
            </div>
          </div>
      )

    }
  }
}